import { render, staticRenderFns } from "./TdcV0.vue?vue&type=template&id=4b8cc818&scoped=true&"
import script from "./TdcV0.vue?vue&type=script&lang=js&"
export * from "./TdcV0.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8cc818",
  null
  
)

export default component.exports